import { errorMessage } from "../../common/message";
import { myAxios } from "../../common/myAxios";

const getDataBulletinBoard = async (data) => {
    try {
        return new Promise((resolve, reject) => {
            myAxios
                .post("/ads-search", data)
                .then((res) => {
                    resolve(res.data.data);
                })
                .catch((error) => {
                    errorMessage(error, reject);
                });
        });
    } catch (error) {
        console.error("Error in Bulletin Board listing", error);
    }
};
export { getDataBulletinBoard };
